import { Link } from 'react-router-dom';
import { forumTopics } from '@/mocks/forum';
import TopicRow from '@/components/base/TopicRow';

const hot = forumTopics.filter((t) => t.hot).slice(0, 4);

export default function HotTopics() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">社区热门讨论</h2>
        <Link to="/forum" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          进入社区 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="flex flex-col gap-3">
        {hot.map((t) => (
          <TopicRow key={t.id} topic={t} />
        ))}
      </div>
    </section>
  );
}